export default __webpack_public_path__ + "static/media/garware-icecool.511cea55.webp";